<template>
    <button class="ibutton ibtn d-flex-center font-medium"
        :class="btnClasses">
        {{ text }}
    </button>
</template>

<script>
export default {
    name: "IButton",
    props: {
        text: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'primary'
        }
    },
    data(){
        return {
            mapTypeClass: {
                'primary': 'ibtn-primary',
                'primary-light': 'ibtn-primary-light',
                'white': 'ibtn-white',
                'white-b': 'ibtn-white-b',
                'dark': 'ibtn-dark',
                'dark-b': 'ibtn-dark-b'
            }
        }
    },
    computed: {
        btnClasses(){
            return this.mapTypeClass[this.type] || '';
        }
    }
}
</script>

<style scoped>
.ibtn{
    --height-btn: 60px;
    --border-color: transparent;
    --background-color: var(--color-base-00);
    --color-text: var(--color-base-100);

    height: clamp(var(--height-btn), var(--height-btn), var(--height-btn));

    border-width: 1px;
    border-style: solid;
    border-color: var(--border-color);

    background-color: var(--background-color);
    color: var(--color-text);

    padding: 14px 24px;
    border-radius: 100px;

    cursor: pointer;
    white-space: nowrap;
}
.ibtn-primary{
    --color-primary: var(--color-primary-500);

    --border-color: var(--color-primary);
    --background-color: var(--color-primary);
    --color-text: var(--color-base-00);
}
.ibtn-primary-light{
    --color-primary: var(--color-base-00);

    --border-color: var(--color-primary-500);
    --background-color: var(--color-primary);
    --color-text: var(--color-primary-500);
}
.ibtn-white{
    --color-primary: var(--color-base-00);
    --border-color: var(--color-primary);
    --background-color: var(--color-primary);
    --color-text: var(--color-base-100);
}
.ibtn-white-b{
    --color-primary: var(--color-base-00);
    --border-color: var(--color-grey-300);
    --background-color: var(--color-primary);
    --color-text: var(--color-base-100);
}
.ibtn-dark{
    --color-primary: var(--color-base-100);
    --border-color: var(--color-primary);
    --background-color: var(--color-primary);
    --color-text: var(--color-base-00);
}
.ibtn-dark-b{
    --color-primary: var(--color-base-100);
    --border-color: var(--color-base-00);
    --background-color: var(--color-primary);
    --color-text: var(--color-base-00);
}
</style>